import { makeAutoObservable } from 'mobx'

import { BuyTicketApi } from 'shared/api/BuyTicket.ts'
import { PassportItem } from 'shared/api/PassportInfo.ts'

class SerialDocumentStore {
  info?: PassportItem[]

  constructor() {
    makeAutoObservable(this)
  }

  async getSerialDocumentInfo() {
    try {
      const { data: response } = await BuyTicketApi.getSerialDocumentInfo()

      this.info = response?.data
    } catch {}
  }
}

export default new SerialDocumentStore()
